// en.js
export default {
  appText: "NIM H5",
  messageText: "Message",
  contactText: "Contacts",
  welcomeText: "Welcome to Netease NIM",
  mineText: "Me",
  logoutText: "Log out",
  commsEaseText: "About NIM",
  logoutConfirmText: "Are you sure you want to log out?",
  avatarText: "Avatar",
  accountText: "Account",
  name: "Nickname",
  genderText: "Gender",
  remark: "remark",
  mobile: "Phone",
  email: "Email",
  sign: "Signature",
  man: "Male",
  woman: "Female",
  unknow: "Unknown",
  birthText: "Birthday",
  FriendPageText: "Friend Card",
  startConversationText: "Start Chat",
  addText: "Add",
  applyFriendSuccessText: "Request Sent",
  applyFriendFailText: "Request Failed",
  addFriendText: "Add Friend",
  addFriendFailText: "Add Friend Failed",
  deleteFriendText: "Delete Friend",
  deleteFriendConfirmText: "Are you sure you want to delete this friend?",
  deleteFriendSuccessText: "Delete Friend Success",
  deleteFriendFailText: "Delete Friend Failed",
  setBlackFailText: "Add to blacklist failed",
  removeBlackFailText: "Remove from blacklist failed",
  removeBlackSuccessText: "Remove from blacklist success",
  addPermissionText:
    "Please add relevant permissions in the system settings page",
  FailAvatarText: "Avatar upload failed",
  chooseDefaultImage: "Choose default image",
  chatButtonText: "Go to Chat",
  gotoChatFailText: "Go to chat failed",
  chatWithFriendText: "Chat",
  okText: "OK",
  updateText: "Update",
  cancelText: "Cancel",
  friendSelectText: "Select Friend",
  telErrorText: "Invalid phone number format",
  emailErrorText: "Invalid email format",
  createButtonText: "Create",
  createP2PText: "Start Chat",
  createTeamText: "Create Team",
  addTeamMemberText: "Add Team Member",
  addChatMemberText: "Add Chat Member",
  addTeamMemberSuccessText: "Add Team Member Success",
  addTeamMemberFailText: "Add Team Member Failed",
  teamTitlePlaceholder: "Enter Team Name",
  maxSelectedText: "You can only select up to 200 friends",
  createTeamSuccessText: "Create Team Success",
  createTeamFailedText: "Create Team Failed",
  PersonalPageText: "PersonalCard",
  deleteSessionText: "Delete",
  sessionMuteText: "Mute Notifications",
  sessionMuteFailText: "Mute Notifications Failed",
  sessionUnMuteFailText: "Unmute Notifications Failed",
  stickTopText: "Pin Chat",
  deleteStickTopText: "Unpin Chat",
  addStickTopText: "Pin",
  deleteSessionFailText: "Delete Conversation Failed",
  deleteStickTopFailText: "Unpin Chat Failed",
  addStickTopFailText: "Pin Message Failed",
  teamMemberText: "Team Members",
  saveText: "Save",
  setText: "Settings",
  failText: "Failed",
  saveSuccessText: "Save Success",
  saveFailedText: "Save Failed",
  searchTeamPlaceholder: "Enter Team Name",
  teamTitle: "Team Name",
  teamInfoText: "Team Infomation",
  teamIntro: "Introduction",
  teamAnnouncement: "Announcement",
  teamAvatar: "Team Avatar",
  networkError: "Current network error",
  searchFailText: "Search Failed",
  offlineText: "Network is unavailable, please check network settings.",
  connectingText:
    "The current IM connection has been disconnected and is reconnecting…",
  teamMenuText: "My Groups",
  teamChooseText: "My Team Chats",
  chooseText: "Choose",
  friendSelect: "Please select a contact",
  getHistoryMsgFailedText: "Failed to get message history",
  deleteText: "Delete",
  recallText: "Recall",
  copyText: "Copy",
  forwardText: "Forward",
  forwardComment: "forward comment",
  replyText: "Reply",
  replyNotFindText: "Message has recalled or deleted",
  forwardToTeamText: "Forward to Team",
  forwardToFriendText: "Forward to Contact",
  sessionRecordText: "Conversation Record",
  chatInputPlaceHolder: "What would you like to say?",
  enableV2CloudConversationText: "Enable V2 Cloud Conversation",
  SwitchToEnglishText: "Switch to English",
  pinText: "Mark",
  pinFailedText: "Mark Failed",
  unpinText: "Unmark",
  unpinFailedText: "Unmark Failed",
  noPinListText: "No Mark",
  receiveText: "new message coming",
  collectionText: "Collection",
  deleteCollectionText: "Delete collection",
  addCollectionSuccessText: "Add collection success",
  addCollectionFailedText: "Add collection Failed",
  deleteCollectionFailedText: "Delete collection Failed",
  deleteCollectionConfirmText:
    "Are you sure you want to delete this collection?",
  noCollectionsText: "No collection",
  teamBannedText: "Message Banned",
  you: "You",
  pinThisText: "Marked this message",
  delete: "Delete this message",
  recall: "Recalled a message",
  recall2: "This message has been recalled",
  recall3: "Recall this message",
  recallMsgFailText: "Recall Message Failed",
  reeditText: "Edit",
  loadingMoreText: "Loading…",
  loadingText: "Loading...",
  noMoreText: "No more",
  deleteMsgSuccessText: "Delete Success",
  deleteMsgFailText: "Delete Failed",
  conversationEmptyText: "empty",
  teamOwner: "Team Owner",
  teamManager: "Team Manager",
  teamEmptyText: "NoGroup Chats",
  muteSessionText: "Mute Conversation",
  unmuteSessionText: "Cancel Mute",
  blacklistEmptyText: "No Blocked Contacts",
  blacklistSubTitle: "You will not get messages from anyone on the list.    ",
  validEmptyText: "No Verification Messages",
  dismissTeamText: "Dismiss Team",
  dismissTeamConfirmText: "Are you sure you want to dismiss this team?",
  leaveTeamTitle: "Leave Team",
  leaveTeamConfirmText: "Are you sure you want to leave this team?",
  leaveTeamSuccessText: "You have left this team",
  leaveTeamFailedText: "Failed to leave this team",
  dismissTeamSuccessText: "Dismiss Team Success",
  dismissTeamFailedText: "Dismiss Team Failed",
  updateTeamSuccessText: "Update Success",
  updateTeamFailedText: "Update Failed",
  teamTitleConfirmText: "Team name cannot be empty",
  teamIntroConfirmText: "Team introduction cannot be empty",
  aliasConfirmText: "Alias cannot be empty",
  sendImageFailedText: "Failed to send Image",
  sendVideoFailedText: "Failed to send Video",
  sendAudioFailedText: "Failed to send Audio",
  sendFileFailedText: "Failed to send File",
  sendMsgFailedText: "Failed to send Message",
  tipText: "tip",
  selectImageText: "please select image",
  friendEditPlaceholder: "Please enter the friend's nickname",
  uikitVersion: "Version",
  IMVersion: "IM Version",
  productInfoText: "Product Info",
  joinTeamFailedText: "Join Team Failed",
  joinTeamLimitText: "Team member limit reached",
  teamMuteText: "Team Mute",

  weekText: "Weeks ago",
  dayText: "Days ago",
  hourText: "Hours ago",
  minuteText: "Minutes ago",
  nowText: "Just now",
  sendText: "Send",
  sendToText: "Send to",
  textMsgText: "Text Message",
  audioMsgText: "Audio Message",
  videoMsgText: "Video Message",
  fileMsgText: "File Message",
  callMsgText: "Call Message",
  geoMsgText: "Location Message",
  imgMsgText: "Image Message",
  notiMsgText: "Notification Message",
  updateAllowAt: "Update Allow At",
  openText: "Open",
  closeText: "Close",
  robotMsgText: "Robot Message",
  tipMsgText: "Tip Message",
  customMsgText: "Custom Message",
  unknownMsgText: "Unknown Message",
  noFriendText: "No Friends",
  teamManagerSelect: "Team Manager",
  onDismissTeamText: "This team has been dismissed",
  onRemoveTeamText: "You have left the team",
  onRemoveDiscussionText: "You have left the discussion group",
  discussionText: "Discussion Group",
  discussionTitleText: "Discussion Group",
  discussionAvatarText: "Discussion Group Avatar",

  discussionIdText: "Discussion Group ID",
  discussionTitle: "Discussion Group Name",
  searchDiscussionMemberPlaceholder: "Search Discussion Group Members",
  selectSessionFailText: "Failed to select conversation",
  noExistUser: "This user does not exist",
  enterAccount: "Enter account",
  placeHolderText: "Please enter the message",
  updateTeamMute: "Update Team Mute",
  validMsgText: "Verification",
  blacklistText: "Blocked Contacts",
  applyTeamText: "Apply to Join Team",
  joinTeamSuccessText: "Join Team Success",
  acceptResultText: "Accepted",
  rejectResultText: "Rejected",
  rejectTeamInviteText: "Rejected team invitation",
  beRejectResultText: "Rejected friend request",
  passResultText: "Accepted friend request",
  acceptedText: "This request has been accepted",
  acceptFailedText: "Failed to accept this request",
  rejectedText: "This request has been rejected",
  rejectFailedText: "Failed to reject this request",
  passFriendAskText:
    "I have accepted your friend request, let's start chatting!",
  applyFriendText: "Add you as a friend",
  rejectText: "Reject",
  acceptText: "Accept",
  inviteTeamText: "Invite to Team",
  confirmText: "Confirm",
  addBlacklist: "Block",
  removeBlacklist: "Unblock",
  forwardSuccessText: "Forward Success",
  forwardFailText: "Forward Failed",
  getMessageFailed: "Fail to get message",
  getForwardMessageFailed: "Fail to get forward message",
  updateBitConfigMaskSuccess: "Update group message notification success",
  updateBitConfigMaskFailed: "Update group message notification failed",
  teamDoNotDisturbText: "Team Mute",
  discussionDoNotDisturbText: "Discussion Group Mute",
  sendFailWithInBlackText:
    "The other party has blocked you, message sending failed",
  sendFailWithDeleteText:
    "The relationship between both parties has been terminated, please reapply for contact",
  friendVerificationText: "Friend Verification",
  teamAll: "all",
  chooseMentionText: "Choose Mention",
  someoneText: "someone",
  meText: "mention",
  teamMutePlaceholder: "The current team owner has set the team to mute",
  viewMoreText: "View More",
  resendMsgFailText: "Resend Failed",
  audioBtnText: "Press and hold to speak",
  audioRemindText: "Release to send",
  audioErrorText: "Recording failed",
  videoPlayText: "Video Play",
  voiceCallText: "Voice Call",
  videoCallText: "Video Call",
  callDurationText: "call duration",
  teamIdText: "Team ID",
  callCancelText: "canceled",
  callRejectedText: "rejected",
  callTimeoutText: "Missed call",
  callBusyText: "busy line",
  callFailedText: "call failed",
  wxAppFileCopyText: "Please paste the URL in the mobile browser.",
  shootText: "shoot",
  albumText: "album",
  msgReadPageTitleText: "Message Reading Status",
  readText: "Read",
  unreadText: "Unread",
  fileText: "file",
  allUnReadText: "All Unread",
  msgRecallTimeErrorText: "Message recall time exceeded",
  allReadText: "All Read",
  searchText: "Search",
  searchTitleText: "Search",
  friendText: "Friend",
  imgText: "Image",
  videoText: "Video",
  teamText: "Team",
  searchResultNullText: "User does not exist",
  conversationSendFailText: "[Send Failed]",
  conversationNotificationText: "[Notification]",
  fileMsgTitleText: "[File Message]",
  collectionFromText: "Collection from",
  copySuccessText: "Copy Success",
  openUrlText: "Copied. Open in browser.",
  teamManagerText: "Team Manager",
  teamManagerSettingText: "Team Manager Setting",
  updateTeamInfoText: "Who is allowed to edit team details",
  teamOwnerAndManagerText: "TeamOwnerAndManager",
  updateTeamInviteText: "Who is allowed to invite team members",
  updateTeamAtText: "Who is allowed to @",
  addMemberText: "Add Member",
  removeText: "remove",

  securityTipText:
    "For test only. Beware of money transfer, lottery winnings & strange call scams.",
  strangerTipText:
    "You are not friends yet, please protect your personal privacy and security",
  sendToFriend: "send to friend",
  sendToTeam: "send to team",
  recentConversationText: "recent",
  searchButtonText: "search",
  accountNotMatchText: "Account does not exist",
  teamIdNotMatchText: "Team does not exist",
  selectedText: "selected",
  personUnit: "person",
  teamIdPlaceholder: "Please enter team ID",
  editNickInTeamText: "Edit my nickname in the team",
  uploadLimitText: "Upload limit 100Mb",

  // UserCardModal related text
  unblacklistText: "Unblock",
  blacklistFriendText: "Block Friend",
  deleteFriendMenuText: "Delete Friend",
  setNicknamePlaceholder: "Set Nickname",
  sendMessageText: "Send Message",
  aliasText: "Alias",
  unknownText: "Unknown",
  blacklistSuccessText: "Blocked",
  unblacklistSuccessText: "Unblocked",
  blacklistFailText: "Block failed",
  unblacklistFailText: "Unblock failed",
  saveAliasSuccessText: "Alias saved successfully",
  saveAliasFailedText: "Failed to save alias",
  searchNoResText: "No search results",
  msgNetworkErrorText: "Network error, sending failed",
  myFriendsText: "My Friends",
  searchTeamMemberPlaceholder: "Search team members",
  joinTeamText: "Join Team",
  mobilePlaceholderText: "Please enter mobile number",
  nickPlaceholderText: "Please enter nickname",
  signPlaceholderText: "Please enter signature",
  emailPlaceholderText: "Please enter email",
  teamManagerEditInfoText: "Team Manager Edit Info",
  updateTeamManagerSuccessText: "Update team manager success",
  updateTeamManagerFailText: "Update team manager fail",

  createDiscussionText: "Create Discussion",
  createDiscussionSuccessText: "Create discussion group successfully",
  createDiscussionFailedText: "Create discussion group failed",
  discussionMemberText: "Discussion group member",
  leaveDiscussionTitle: "Leave Discussion Group",
  leaveDiscussionConfirmText:
    "Are you sure you want to leave this discussion group?",
  leaveDiscussionSuccessText: "Successfully left this discussion group",
  leaveDiscussionFailedText: "Failed to leave this discussion group",
  alreadyInTeamText: "You are already in the team",

  //demo层
  session: "session",
  addressText: "contacts",
  sdkVersionSelectionText: "SDK version",
  p2pMsgVisibleModeText: "Read receipts for private messages",
  teamMsgVisibleModeText: "Read receipts for group messages",
  addFriendMode: "Verification for friend requests",
  yesText: "Enable",
  noText: "Disable",
  needVerifyText: "Required",
  notNeedVerifyText: "Not required",
  settingText: "setting",
  oppositeSide: "The opposite side",
  networkDisconnectText:
    "The network connection has been disconnected. Please check your network settings and try to reconnect.",
  callFailed: "call failed",
  inCallText: "Already in a call, please try again after ending the call",
  needMentionText: "Whether or not an @ message is needed",
  teamManagerEnableText: "Whether or not team manager is needed",
  zhText: "中文",
  enText: "English",
  aiStreamText: "AI Stream",
  teamJoinModeText: "Team join mode",
  teamJoinModeFreeText: "Free join, no verification required",
  teamJoinModeNeedVerifyText:
    "Need to apply, join after the group owner or manager approves",
  teamAgreeModeText: "Team agree mode",
  needBeInvitedText: "Need to be invited by the invitee",
  notNeedBeInvitedText: "No need to be invited by the invitee",

  // emoji 不能随便填，要用固定 key
  Laugh: "[Laugh]",
  Happy: "[Happy]",
  Sexy: "[Sexy]",
  Cool: "[Cool]",
  Mischievous: "[Mischievous]",
  Kiss: "[Kiss]",
  Spit: "[Spit]",
  Squint: "[Squint]",
  Cute: "[Cute]",
  Grimace: "[Grimace]",
  Snicker: "[Snicker]",
  Joy: "[Joy]",
  Ecstasy: "[Ecstasy]",
  Surprise: "[Surprise]",
  Tears: "[Tears]",
  Sweat: "[Sweat]",
  Angle: "[Angle]",
  Funny: "[Funny]",
  Awkward: "[Awkward]",
  Thrill: "[Thrill]",
  Cry: "[Cry]",
  Fretting: "[Fretting]",
  Terrorist: "[Terrorist]",
  Halo: "[Halo]",
  Shame: "[Shame]",
  Sleep: "[Sleep]",
  Tired: "[Tired]",
  Mask: "[Mask]",
  ok: "[ok]",
  AllRight: "[All right]",
  Despise: "[Despise]",
  Uncomfortable: "[Uncomfortable]",
  Disdain: "[Disdain]",
  ill: "[ill]",
  Mad: "[Mad]",
  Ghost: "[Ghost]",
  Angry: "[Angry]",
  Unhappy: "[Unhappy]",
  Frown: "[Frown]",
  Broken: "[Broken]",
  Beckoning: "[Beckoning]",
  Ok: "[Ok]",
  Low: "[Low]",
  Nice: "[Nice]",
  Applause: "[Applause]",
  GoodJob: "[Good job]",
  Hit: "[Hit]",
  Please: "[Please]",
  Bye: "[Bye]",
  First: "[First]",
  Fist: "[Fist]",
  GiveMeFive: "[Give me five]",
  Knife: "[Knife]",
  Hi: "[Hi]",
  No: "[No]",
  Hold: "[Hold]",
  Think: "[Think]",
  Pig: "[Pig]",
  NoListen: "[No listen]",
  NoLook: "[No look]",
  NoWords: "[No words]",
  Monkey: "[Monkey]",
  Bomb: "[Bomb]",
  Cloud: "[Cloud]",
  Rocket: "[Rocket]",
  Ambulance: "[Ambulance]",
  Poop: "[Poop]",
  // 错误码及提示内容
  // 通用错误码
  190001: "internal error",
  190002: "illegal state",
  191001: "misuse",
  191002: "cancelled",
  191003: "callback failed",
  191004: "invalid parameter",
  191005: "timeout",
  191006: "resource not exist",
  191007: "resource already exist",
  // 连接相关
  192001: "connect failed",
  192002: "connect timeout",
  192003: "disconnected",
  192004: "protocol timeout",
  192005: "protocol send failed",
  192006: "request failed",
  // 消息相关
  107319: "PIN limit exceeded",
  107320: "PIN not exist",
  107322: "PIN already exist",
  107327: "PIN function disabled",
  189301: "collection limit exceeded",
  189302: "collection not exist",
  189449: "collection concurrent operation failed",
  // 群相关
  109432: "no permission",
};
